import { Data, Logger } from './types';

export const SAVE_DATA_KEY: string = 'sg_sofa_data';

/**
 * if true, logs verbose info to console
 */
export const DBG_SAVE_MODE: boolean = false;

/**
 * Abstract class for the savedata utilities
 */
export abstract class BaseSaver<T extends Data> {
  protected abstract _cache: object;
  protected abstract _throttleMS: number;
  protected abstract _throttlePromise: Promise<void>;
  protected logger: Logger;

  protected abstract throttle(): Promise<void>;

  protected constructor() {
    // Should not be instantiated
  }

  public abstract save(data: Partial<T>): Promise<void>;

  public abstract load(keys?: string[]): Promise<T>;

  public abstract clear(): Promise<void>;

  public abstract get saveDataKey(): string;

  public abstract get enabled(): boolean;

  protected updateCache(data: Partial<T>): void {
    this._cache = Object.assign(this._cache || {}, data);
  }

  public setLogger(logger: Logger): void {
    this.logger = logger;
  }
}
